// Faixas da comissão recorrente da revenda, pelo número de clientes na carteira.
// A escada de /revenda e o simulador leem daqui.
export const FAIXAS_RECORRENTE = [
  { min: 1, max: 10, percentual: 20 },
  { min: 11, max: 25, percentual: 25 },
  { min: 26, max: 50, percentual: 30 },
  { min: 51, max: null, percentual: 35 },
];

// Teto da comissão na venda ("até 80%"), sobre a primeira mensalidade de cada cliente fechado.
export const PERCENTUAL_PRIMEIRA_MENSALIDADE = 80;

export function rotuloFaixa({ min, max }) {
  return max ? `${min} a ${max} clientes` : `${min}+ clientes`;
}

// Carteira vazia não tem faixa.
export function faixaDaCarteira(clientes) {
  return [...FAIXAS_RECORRENTE].reverse().find(f => clientes >= f.min) || null;
}
